<template>

  <!-- Page Block Header -->
  <div
    class="page-block-header">

    <div
      class="row q-col-gutter-x-md q-col-gutter-y-sm">

      <div
        class="page-block-header__left col-12 col-sm-grow">

        <img
          v-if="!noElement"
          src="/images/element/element-head.svg"
          class="page-block-header__element xs-hide"/>

        <h2
          class="text-bold q-my-none"
          v-html="$u.nToBr($u.localize(value.title))">
        </h2>

      </div>

      <div
        class="col-12 col-sm-shrink">

        <slot/>

      </div>

    </div>

  </div>

</template>

<script>

  export default {
    name: 'page-block-header',
    props: {
      value: {
        type: Object,
        default: () => {},
      },
      noElement: {
        type: Boolean,
        default: false,
      },
    },
  };

</script>

<style lang="scss">

  .page-block-header {
    color: inherit;

    &__left {
      position: relative;
    }

    h2 {
      position: relative;
    }

    &__element {
      left: -68px;
      bottom: -56px;
      position: absolute;
    }
  }

</style>
